module.exports = __webpack_public_path__ + "static/media/celeste.9f7c30d4.jpg";